import { render } from "./ChpPhysiciansSearchInput.vue?vue&type=template&id=181ecbd3"
import script from "./ChpPhysiciansSearchInput.vue?vue&type=script&lang=js"
export * from "./ChpPhysiciansSearchInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Website\\wwwroot\\FrontendCHP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__